import { FormattedMessage } from '@alltrails/shared/react-intl';
import OriginalLanguageButton from '../../../../components/shared/OriginalLanguageButton';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { localizeContent } from 'api/localizations';
import CustomProvider from 'components/CustomProvider';

const maxDescriptionLength = 1000;

const createReactClass = require('create-react-class');

const DescriptionHolder = createReactClass({
  getInitialState() {
    return {
      descriptionLength: this.props.descriptionSource?.length ?? this.props.description?.length,
      submitInProgress: false,
      isEditShown: false,
      showMoreButton: false,
      descFullyDisplayed: false,
      localeContent: null
    };
  },
  componentDidMount() {
    if (window.elementHasOverflow('description-box')) {
      this.setState({ showMoreButton: true });
    }
  },
  show() {
    this.setState({ isEditShown: true });
  },
  hide() {
    this.setState({ isEditShown: false });
  },
  toggleShowMore() {
    this.setState({ descFullyDisplayed: !this.state.descFullyDisplayed });
  },
  submit() {
    this.setState({ submitInProgress: true });
    let url;
    if (this.props.modelName === 'lists') {
      url = `/api/alltrails/lists/${this.props.modelId}`;
    } else {
      url = `/api/alltrails/locations/${this.props.modelName}/${this.props.modelId}`;
    }
    const params = {
      description: this.refs.descriptionText.value
    };

    ServerCommunicationUtil.putApiEndpoint(
      url,
      params,
      function () {},
      function () {},
      function () {
        this.setState({ submitInProgress: false });
        window.location.reload();
      }.bind(this)
    );
  },
  async toggleShowInTranslatedLang() {
    const { localeContent } = this.state;

    if (!localeContent) {
      const content = await localizeContent('lists', 'description', this.props.modelId);
      this.setState({ localeContent: content });
    }

    this.setState({ showInSourceLang: !this.state.showInSourceLang });
  },
  render() {
    let tabContainer;
    if (this.state.isEditShown) {
      const statusText = this.state.submitInProgress ? <FormattedMessage defaultMessage="Saving..." /> : '';
      const buttonContainer = (
        <div className="edit-buttons">
          <span className="link btn btn-slim" onClick={this.submit}>
            <FormattedMessage defaultMessage="Save" />
          </span>
          <span className="link" onClick={this.hide}>
            <FormattedMessage defaultMessage="Cancel" />
          </span>
          <span className="list-description-count">
            {this.state.descriptionLength} / {maxDescriptionLength}
          </span>
          <b>{statusText}</b>
        </div>
      );
      tabContainer = (
        <div className="tab-container">
          <div id="trail-detail-item" className="tab-content overview">
            <textarea
              ref="descriptionText"
              className="overview"
              maxLength={maxDescriptionLength}
              onInput={e => this.setState({ descriptionLength: e.target.value.length })}
              defaultValue={this.props.descriptionSource || this.props.description}
              autoFocus
            />
            {buttonContainer}
          </div>
        </div>
      );
    } else {
      let editLink;
      if (this.props.allowEdits) {
        editLink = (
          <span className="link suggest-edit" onClick={this.show}>
            <FormattedMessage defaultMessage="Edit" />
          </span>
        );
      }
      let moreBtn;
      if (this.state.showMoreButton && !this.state.isEditShown) {
        const link = this.state.descFullyDisplayed ? (
          <FormattedMessage defaultMessage="Show less" />
        ) : (
          <FormattedMessage defaultMessage="Show more" />
        );
        moreBtn = (
          <div className="show-more-container">
            <a onClick={this.toggleShowMore}>{link}</a>
          </div>
        );
      }
      let descClass = '';
      let tabContainerStyle = {};
      if (!this.state.descFullyDisplayed) {
        descClass = 'line-clamp-4';
      } else if (!this.props.allowEdits) {
        tabContainerStyle = { paddingBottom: '30px' };
      }

      let description;
      if (this.state.showInSourceLang && this.props.descriptionSource) {
        description = this.props.descriptionSource;
      } else if (this.props.description) {
        description = this.props.description;
      }
      const shouldShowOrigLangBtn = this.props.descriptionSource && this.props.descriptionSource != this.props.description;

      let langButton = null;
      if (shouldShowOrigLangBtn) {
        langButton = (
          <OriginalLanguageButton active={this.state.showInSourceLang} handleClick={this.toggleShowInTranslatedLang} eventSource="Description" />
        );
      }

      tabContainer = (
        <div className="tab-container human-gen" style={tabContainerStyle}>
          <div id="trail-detail-item" className="tab-content overview">
            <p id="description-box" className={descClass}>
              {description}
            </p>
            {langButton}
            {editLink}
            {moreBtn}
          </div>
        </div>
      );
    }

    return (
      <CustomProvider>
        <div>
          <div className="row">
            <div className="content-menu">
              <h3>
                <FormattedMessage defaultMessage="description" />
              </h3>
            </div>
          </div>
          {tabContainer}
        </div>
      </CustomProvider>
    );
  }
});

export { DescriptionHolder };
